import script from "./NewBrandNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./NewBrandNavigation.vue?vue&type=script&setup=true&lang=js"

import "./NewBrandNavigation.vue?vue&type=style&index=0&id=178e657e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-178e657e"]])

export default __exports__